import React, { Fragment } from 'react';
import _ from 'lodash';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';

import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import NumberField from '../../../Base/NumberField';

const typeOfFuel = ["HFO 180", "HFO 380", "MGO", "LS MGO", "LNG"];

class Bunkers extends React.Component {
    constructor(props) {
        super(props);
        
        this.addBunker = this.addBunker.bind(this);
        this.removeBunker = this.removeBunker.bind(this);
    }

    addBunker() {
        const bunkers = _.cloneDeep(this.props.bunkers);

        bunkers.push({
            quantity: undefined,
            typeOfFuel: '',
        });

        this.props.changeField({ field: 'bunkers', value: bunkers });
    }

    removeBunker(index) {
        const bunkers = _.cloneDeep(this.props.bunkers);
        bunkers.splice(index, 1);
        this.props.changeField({ field: 'bunkers', value: bunkers });
    }

    render() {
        const { changeField, getError, bunkers, confirmed, modifiedFields, underStyle } = this.props;

        return (
            <Fragment>
                {
                    bunkers.map((bunker, index) => {
                        return (
                            <div key={index} className='row'>
                                <div className='col-xs-3'>
                                    <SelectField
                                        value={bunker.typeOfFuel || ''}
                                        onChange={(e, i, value) => {
                                            changeField({
                                                field: `bunkers[${index}].typeOfFuel`,
                                                value,
                                            });
                                        }}
                                        disabled={confirmed}
                                        errorText={getError(`bunkers.${index}.typeOfFuel`)}
                                        maxHeight={200}
                                        name='typeOfFuel'
                                        floatingLabelText='Type of Fuel'
                                        fullWidth

                                        underlineStyle={modifiedFields && modifiedFields.includes(`bunkers[${index}].typeOfFuel`) ? underStyle : null}

                                    >
                                        {
                                            typeOfFuel.map((type, index) => {
                                                return (<MenuItem
                                                    key={index}
                                                    value={type}
                                                    primaryText={type}
                                                />);
                                            })
                                        }
                                    </SelectField>
                                </div>
                                <div className='col-xs-3'>
                                    <NumberField
                                        name='bunkers.quantity'
                                        floatingLabelText='Quantity, mt'
                                        value={bunker.quantity || ''}
                                        fullWidth
                                        floatNumber
                                        disabled={!bunker.typeOfFuel}
                                        errorText={getError(`bunkers.${index}.quantity`)}
                                        onChange={(e, value) => {
                                            changeField({
                                                field: `bunkers[${index}].quantity`,
                                                value,
                                                type: 'number',
                                            });
                                        }}

                                        underlineStyle={modifiedFields && modifiedFields.includes(`bunkers[${index}].quantity`) ? underStyle : null}
                                    />
                                </div>
                                <div className='col-xs-1 middle-xs center-xs' style={{ display: 'flex' }}>
                                    <div style={{ margin: '25px 0 0 0' }}>
                                        {
                                            index === 0 ?
                                                <IconButton
                                                    disabled={confirmed}
                                                >
                                                    <ContentAddIcon
                                                        onClick={this.addBunker}
                                                        color='green'
                                                    />
                                                </IconButton>
                                                :
                                                <IconButton
                                                    disabled={confirmed}
                                                >
                                                    <ContentRemoveIcon
                                                        onClick={() => {
                                                            this.removeBunker(index);
                                                        }}
                                                        color='red'
                                                    />
                                                </IconButton>
                                        }
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </Fragment>);
    }
}

export default Bunkers;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Bunkers.jsx